const printButton = document.querySelector('#print-button');

const activatePrintButton = () => {
  if (printButton) {
    printButton.addEventListener('click', (evt) => {
      evt.preventDefault();
      window.print();
    });
  }
};

export default activatePrintButton;
